import Vue from 'vue';
import gsap from 'gsap';

Vue.component('pop-out-filter-component', {
    props: {
        defaultFilterValue: {
            type: String,
        },

        defaultPillValue: {
            type: String,
        },

        filters: {
            type: Array,
            default: [],
        },

        countries: {
            type: Array,
            default: [],
        },
    },
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            showContent: false,
            categoryTitle: null,
            enabledCategories: [],
            filterCollection: [],
            pillsCollection: [],
        };
    },

    watch: {
        showContent() {
            if (this.showContent) {
                document.body.classList.add('body-lock');
                return;
            }

            document.body.classList.remove('body-lock');
        },
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        if (this.defaultFilterValue) {
            this.filterCollection = [...this.filterCollection, this.defaultFilterValue];
            this.enabledCategories = [...this.enabledCategories, this.defaultFilterValue];
        }

        if (this.defaultPillValue) {
            this.pillsCollection = [...this.pillsCollection, this.defaultPillValue];
            this.enabledCategories = [...this.enabledCategories, this.defaultPillValue];
        }

        // EMIT CATEGORIES
        this.$emit('categories-emitted', this.enabledCategories);

        EventBus.$on('window-resize', () => {
            if (window.innerWidth >= 768 && this.showContent && document.body.classList.contains('body-lock')) {
                document.body.classList.remove('body-lock');
            }
        });
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        filterOptionChange(category) {
            this.filterCollection = [];
            this.filterCollection = [...this.filterCollection, category.value];
            this.emitCategories();
        },

        emitCategories() {
            this.enabledCategories = [...this.filterCollection, ...this.pillsCollection];
            this.$emit('categories-emitted', this.enabledCategories);
        },

        toggleDropdown(categoryId, filter, categoryTitle = null, multiple = false) {
            if (filter) {
                this.toggleFilter(filter);
            }

            if (!multiple) {
                // Remove previous found in locale array
                this.filterCollection = [];
            }

            if (categoryTitle) {
                this.categoryTitle = categoryTitle;
            }

            const localeIndex = this.filterCollection.indexOf(categoryId);

            // If already in, toggle it of since there is multiple selection enabled
            if (localeIndex !== -1) {
                this.filterCollection.splice(localeIndex, 1);
                this.emitCategories();
                return;
            }

            // If multiple set add it
            this.filterCollection = [...this.filterCollection, categoryId];
            this.emitCategories();
        },

        togglePill(categoryId, filter, multiple = false) {
            if (!multiple) {
                // Remove previous found in locale array
                this.pillsCollection = [];
            }

            const localeIndex = this.pillsCollection.indexOf(categoryId);

            // If already in, toggle it of since there is multiple selection enabled
            if (localeIndex !== -1) {
                this.pillsCollection.splice(localeIndex, 1);
                this.emitCategories();
                return;
            }

            // If multiple set add it
            this.pillsCollection = [...this.pillsCollection, categoryId];
            this.emitCategories();
        },

        toggleFilter(filter) {
            const target = this.$refs[filter];

            if (!target) {
                return;
            }

            const filterBlock = target;
            const filterList = target.querySelector('[data-list]');
            const filterArrow = target.querySelector('[data-arrow-holder] svg');
            const tl = gsap.timeline();

            if (filterBlock.classList.contains('active')) {
                filterBlock.classList.remove('active');
                tl
                    .to(filterList, {
                        duration: 0.3,
                        height: 0,
                        ease: 'power4.out',
                    })
                    .to(filterArrow, {
                        duration: 0.3,
                        rotate: '0deg',
                        ease: 'power4.out',
                    }, '<');
                return;
            }

            filterBlock.classList.add('active');
            tl
                .to(filterList, {
                    duration: 0.3,
                    height: 'auto',
                    ease: 'power4.out',
                })
                .to(filterArrow, {
                    duration: 0.3,
                    rotate: '180deg',
                    ease: 'power4.out',
                }, '<');
        },

        onEnter(el, done) {
            gsap.to(el, {
                duration: 0.6,
                x: 0,
                ease: 'power4.out',
                onComplete: done,
            });
        },

        onLeave(el, done) {
            gsap.to(el, {
                duration: 0.6,
                x: window.innerWidth,
                ease: 'power4.out',
                onComplete: done,
            });
        },
    },
});
